module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_es_spanish-37c5897bf25b273cc2a36d67bb9f25ef.svg";